module.exports = __webpack_public_path__ + "static/media/logo.bd13c728.png";